import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
// Styles
import styles from './styles';

const PopupConfirmDialog = ({ open, labels, onConfirm, onClose, classes }) => {
  const { title, message, closeLabel, confirmLabel } = labels;

  const handleConfirm = () => {
    onConfirm()
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div>
      <Dialog
        className={classes.container}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            { message }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirm} color="secondary">
            { confirmLabel }
          </Button>
          <Button onClick={handleClose} color="secondary" autoFocus>
            { closeLabel }
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(PopupConfirmDialog);
